<script setup>
import { onMounted, ref, computed } from 'vue'
import { useMainStore } from '@/store'
import { SCookie } from '@n966/soilbox_ui'

import { updatesConfig } from './components/interface/updates/config'

import UpdatesModal from './components/interface/updates-modal.vue'
import TheHeader from '@/components/interface/the-header.vue'
import OverlayAlert from '@/components/common/overlay-alert.vue'
import { getDataFromLS, saveDataToLS } from './utils'

const windowWidth = ref(null)

const setVHValue = () => {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)

  windowWidth.value = window.innerWidth
}

onMounted(() => {
  setVHValue()

  document.body.classList.add('dark-theme')

  window.addEventListener('resize', setVHValue)
  window.addEventListener('orientationchange', setVHValue)

  const lastUpdateDateString = updatesConfig[0].date
  const lastShowedDateLS = getDataFromLS('last-update-date')

  if (!lastShowedDateLS || lastUpdateDateString !== lastShowedDateLS) {
    mainStore.SET_STATE_FIELD('isShowLastUpdatesModal', true)
    saveDataToLS('last-update-date', lastUpdateDateString)
  }

  mainStore.toggleLoading(false)
})

const mainStore = useMainStore()

const isDesktop = computed(() => {
  return windowWidth.value >= 1200
})

const closeModal = () => {
  mainStore.isShowLastUpdatesModal = false
}
</script>

<template>
  <div
    class="app"
    v-loading="mainStore.isLoading"
  >
    <TheHeader v-if="isDesktop" />
    <div v-if="!isDesktop">
      <overlay-alert />
    </div>
    <router-view v-else />
    <s-cookie />

    <updates-modal
      :show-modal="mainStore.isShowLastUpdatesModal"
      @close-modal="closeModal"
    />
  </div>
</template>

<style lang="scss">
.app {
  height: 100%;
}
</style>
